import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function ConfirmDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {props.option === 'approve' ? "Approve Overloaded?" : "Deny Overloaded?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {props.option === 'approve' ? `Are you sure you want to approve ${props.value}% overloaded on ${props.projectName} project?` : `Are you sure you want to deny overloaded on ${props.projectName} project?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} autoFocus>
            Confirm
          </Button>
          <Button autoFocus onClick={props.handleCloseCancel}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}